export const ADDRESS_TITLE = 'Address';
export const ADDRESS_ENTITY = 'address';
export const ADDRESS_COORDINATE_TITLE = 'Coordinate';
